var _path, _path2;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgChairOff = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.92 2.85L1.5 4.26 4 6.76V8c-1.65 0-3 1.35-3 3v5c0 1.65 1.35 3 3 3v1c0 .55.45 1 1 1s1-.45 1-1v-1h10.24l3.65 3.65 1.41-1.41L2.92 2.85zM14.24 17l-2-2H5v-4c0-.55-.45-1-1-1s-1 .45-1 1v5c0 .55.45 1 1 1h10.24zm-4-4L6 8.76v.02c.61.55 1 1.34 1 2.22v2h3.24z",
  fill: "#00163F"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 13h-1.186l1.999 2H19v-4c0-.55.45-1 1-1s1 .45 1 1v5c0 .55-.45 1-1 1h-.188l1.628 1.629a3.008 3.008 0 001.56-2.63v-5c0-1.65-1.35-3-3-3V6c0-1.65-1.35-3-3-3H7c-.353 0-.691.062-1.006.175L7.818 5H17c.55 0 1 .45 1 1v2.78c-.61.55-1 1.34-1 2.22v2z"
})));
export default SvgChairOff;